/* eslint-disable camelcase */
import formatCurrency from 'lib/format-currency';
import { createSelector } from 'reselect';

export default createSelector(
  (state) => state.count.payload,
  (_, key) => key,
  (payload, key) => {
    let percent = 0;
    const card = payload[key];

    if (!card || !card.data) return { percent, value: null };

    const {
      currency,
      data: {
        aggregations: { current_period, previous_period },
      },
    } = card;

    const currentRepartitionCharge = current_period.total_repartition_charge?.sum?.value || 0;
    const previousRepartitionCharge = previous_period.total_repartition_charge?.sum?.value || 0;

    // Usiamo il valore assoluto per il calcolo e la visualizzazione
    const absCurrentCharge = Math.abs(currentRepartitionCharge);
    const absPreviousCharge = Math.abs(previousRepartitionCharge);

    percent = 100;

    if (absPreviousCharge !== 0) {
      percent = Math.round(((absCurrentCharge - absPreviousCharge) / absPreviousCharge) * 100);
    }

    if (absPreviousCharge === 0 && absCurrentCharge === 0) percent = 0;

    const value = formatCurrency(currency, absCurrentCharge);
    const previousValue = formatCurrency(currency, absPreviousCharge);

    return {
      percent,
      value,
      previousValue,
      rawValue: currentRepartitionCharge
    };
  },
); 